import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export const ApplicationLoader: React.FC<React.PropsWithChildren<unknown>> = () => (
  <div className="application-loader">
    <div>
      <img src={`${process.env.PUBLIC_URL}/img/logo-cssf.png`} title="CSSF logo" alt="CSSF" />
    </div>
    <FontAwesomeIcon icon={faCircleNotch} size="2x" spin />
  </div>
);
